import "react-toastify/dist/ReactToastify.css";
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import translation from './locales/he/translation.json';
import WhitelabelForm from "./screens/WhitelabelForm";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import WhitelabelsDisplay from "./screens/WhitelabelsDisplay";
import OnBoarding from "./screens/OnBoarding";
import Success from "./screens/Success";
import WhitelabelFormV2 from "./screens/WhitelabelFormV2";

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      he: {
        translation: translation,
      },
    },
    lng: 'he',
    interpolation: {
      escapeValue: false,
    },
  });

function App() {

  return (
      <div className="App">
          <Router>
              <Routes>
                  <Route path="/" element={<WhitelabelFormV2/>} />
                  <Route path="/old" element={<WhitelabelForm/>} />
                  <Route path="/dashboard" element={<WhitelabelsDisplay/>} />
                  <Route path="/on-boarding" element={<OnBoarding/>} />
                  <Route path="/success" element={<Success/>} />
              </Routes>
          </Router>
      </div>
  );
}

export default App;
